import React, { useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Question, ResultadoEncuestaSatisfaccionRequest, getDataService_ResponderEncuesta } from
  "../Commons/serviciosMySkyUI/ResultadoEncuestaSatisfaccion.Payload";
import { invokeResponderEncuestaService } from "../Commons/serviciosMySkyUI/ResultadoEncuestaSatisfaccion.Service";
import styles from "./Encuesta.module.css";
import Loading from "../General/Loading";
import ConfirmMessage from "../General/ConfirmMessage";


const Encuesta = ({ apertura, manejaApertura }: any) => {

  const [loading, isLoading] = useState(false);
  const [status, setStatus] = useState("OK");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const [questions, setQuestions] = useState([
    {
      nameElement: "razon-principal-visita",
      noPregunta: 1,
      pregunta: "¿Cuál fue su razón principal para visitar Mi Sky el día de hoy?",
      respuesta: ""
    },
    {
      nameElement: "iradioOptEncontro",
      noPregunta: 2,
      pregunta: "¿Encontró fácilmente la información que buscaba?",
      respuesta: ""
    },
    {
      nameElement: "iradioOptResolvimos",
      noPregunta: 3,
      pregunta: "¿Resolvimos su necesidad?",
      respuesta: ""
    },
    {
      nameElement: "iradioOptAccede",
      noPregunta: 4,
      pregunta: "¿Accede a Mi Sky desde un dispositivo móvil?",
      respuesta: ""
    },
    {
      nameElement: "iradioOptRecomendaria",
      noPregunta: 5,
      pregunta: "¿Recomendaría el portal Mi Sky?",
      respuesta: ""
    },
    {
      nameElement: "iradioOptEvalua",
      noPregunta: 6,
      pregunta: "¿Cómo evaluaría el portal de Mi Sky?",
      respuesta: ""
    },
    {
      nameElement: "txtareaMotivo",
      noPregunta: 7,
      pregunta: "¿Por qué?",
      respuesta: ""
    }
  ]);

  function handleChange(event: any) {
    let indexElement = questions.findIndex((item) => {
      return item.nameElement == event.target.name;
    });

    questions[indexElement].respuesta = event.target.value;
    setQuestions(questions);
  };

  function valida() {
    questions.forEach((item) => {
      if (item.respuesta === "") {
        return true;
      }
    });

    return false;
  }


  const sendResponse = async () => {

    isLoading(true);
    let today = new Date();
    let dateFormat = today.getFullYear() + "" + today.getMonth() + "" + today.getDay() + "" + today.getHours() +
      "" + today.getMinutes() + today.getSeconds();
    let respuestasPreguntas: Question[] = [];

    questions.forEach((item) => {
      let respuestaPregunta: Question = {
        CuentaSKY: sessionStorage.getItem("cuenta")!,
        Comentario: "",
        Folio: dateFormat,
        NoPregunta: item.noPregunta,
        Pais: sessionStorage.getItem("pais")!,
        Paquete: sessionStorage.getItem("Paquete")!,
        Pregunta: item.pregunta,
        Respuesta: item.respuesta,
        UserID: sessionStorage.getItem("cuenta")! + "-01"
      }

      respuestasPreguntas.push(respuestaPregunta);
    }
    );

    let resultadoEncuesta: ResultadoEncuestaSatisfaccionRequest = {
      ListaResultadoEncuestaSatisfaccion: {
        Resultado: respuestasPreguntas
      }
    }


    if (true) {
      const sendEncuestPayload = getDataService_ResponderEncuesta(resultadoEncuesta);

      // Invoca servicio
      let { resp, errorService } = await invokeResponderEncuestaService(sendEncuestPayload);

      if (resp && resp.resultado === "0") {
        setStatus("OK");
        setMessage("Las respuestas han sido enviadas con exito.");
        setShowAlert(true);
        isLoading(false);
        setTimeout(() => {
          setShowAlert(false);
     
          manejaApertura(false);
        }, 3000);


      } else {
        setStatus("ERROR");
        setMessage("Error en el envío.");
        setShowAlert(true);
        isLoading(false);
        setTimeout(() => {
          setShowAlert(false);
     
        }, 3000);

      }

    } else {
      setStatus("ERROR");
      setMessage("Favor de llenar todos los campos.");
      setShowAlert(true);
      isLoading(false);
      setTimeout(() => {
        setShowAlert(false);

      }, 3000);


    }



  }//termina sendResponse



  return (
    <>


      <Loading isLoading={loading} />


      

      <Modal show={apertura} 
      onHide={() => manejaApertura(false)} 
      aria-labelledby="contained-modal-title-vcenter"
      centered size="lg">
        <div className={styles.divMessage} >

        <ConfirmMessage status={status} message={message} showAlert={showAlert} />



        </div>


        <Modal.Header closeButton style={{ borderBottom: "none" }}></Modal.Header>
        <Modal.Body className={styles.bodyModalAviso}>
          <Container>
            <Row>
              <Col>
                <h3 className={styles.tituloModal}>Encuesta de satisfacción</h3>
                <p className={styles.subtituloModal}>Completa esta encuesta y ayúdanos a mejorar</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form className={styles.form}>
                  <Row>
                    <Col xs={12} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 8 }} xl={{ span: 8 }} xxl={{ span: 8 }}>
                      <span className={styles.etiqueta}>
                        ¿Cuál fue su razón principal para visitar Mi Sky el día de hoy?
                      </span>
                      <Form.Select id={questions[0].nameElement} name={questions[0].nameElement}
                        onChange={handleChange}>
                        <option value="" >Seleccionar</option>
                        <option value="contratar-ppv">Contratar pagos por evento</option>
                        <option value="pago-linea">Pago en línea</option>
                        <option value="cambio-paquete">Cambio de paquete</option>
                        <option value="contratar-revista">Contratar revista</option>
                        <option value="solicitud-reparacion">Solicitud de reparación</option>
                        <option value="consulta-saldo">Consulta de saldo</option>
                      </Form.Select>
                    </Col>
                  </Row>
                  <br />
                  <Row>{/**linea 1 */}
                    <Col>
                      <span className={styles.etiqueta}>
                        ¿Encontró fácilmente la información que buscaba?
                      </span>
                      <div >
                        <Form.Check
                          inline
                          label="No"
                          type="radio"
                          value="no"
                          name={questions[1].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          label="Sí"
                          type="radio"
                          value="si"
                          name={questions[1].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                      </div>

                    </Col>
                    <Col>
                      <span className={styles.etiqueta}>
                        ¿Resolvimos su necesidad?
                      </span>
                      <div >
                        <Form.Check
                          inline
                          label="No"
                          type="radio"
                          value="no"
                          name={questions[2].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          label="Sí"
                          type="radio"
                          value="si"
                          name={questions[2].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <Row>{/**linea 2 */}
                    <Col>
                      <span className={styles.etiqueta}>
                        ¿Accede a Mi Sky desde un dispositivo móvil?
                      </span>
                      <div >
                        <Form.Check
                          inline
                          label="No"
                          type="radio"
                          value="no"
                          name={questions[3].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          label="Sí"
                          type="radio"
                          value="si"
                          name={questions[3].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                      </div>

                    </Col>
                    <Col>
                      <span className={styles.etiqueta}>
                        ¿Recomendaría el portal Mi Sky?
                      </span>
                      <div >
                        <Form.Check
                          inline
                          label="No"
                          type="radio"
                          value="no"
                          name={questions[4].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}

                        />
                        <Form.Check
                          inline
                          label="Sí"
                          type="radio"
                          value="si"
                          name={questions[4].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <Row>{/**linea 3 */}
                    <Col>
                      <span className={styles.etiqueta}>
                        ¿Cómo evaluaría el portal de Mi Sky?
                      </span>
                      <div >
                        <Form.Check
                          inline
                          label="Malo"
                          type="radio"
                          value="malo"
                          name={questions[5].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          label="Regular"
                          type="radio"
                          value="regular"
                          name={questions[5].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          label="Bueno"
                          type="radio"
                          value="bueno"
                          name={questions[5].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          label="Muy bueno"
                          type="radio"
                          value="muybueno"
                          name={questions[5].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                        <Form.Check
                          inline
                          label="Excelente"
                          type="radio"
                          value="excelente"
                          name={questions[5].nameElement}
                          id="iradioEncontro1"
                          onChange={handleChange}
                        />
                      </div>

                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col>
                      <Form.Group>
                        <span className={styles.etiqueta}>¿Por qué?</span>
                        <Form.Control maxLength={201} as="textarea" rows={3} style={{ resize: 'none' }}
                          name={questions[6].nameElement} onChange={handleChange} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <br />
                  <Row >
                    <Col className={styles.alineacionBotonesModal}>
                      <Button className={styles.button} style={{ marginBottom: "0px" }} onClick={sendResponse}>
                        <b>Enviar respuesta</b>
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col className={styles.alineacionBotonesModal}>
                      <Button className={styles.botonCancelarModalAviso} onClick={() => manejaApertura(false)}>
                        <b>Cancelar</b>
                      </Button>
                    </Col>
                  </Row>

                </Form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Encuesta